// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"d93b564a004c2112283c","293":"5c09b2c8fb9822cd62ff","518":"597534559b8fc6705064","779":"fe9fd17ecb9b8231662b"}[chunkId] + ".js";
};